import { useEffect, useState } from 'react';
import { wsClient, type WSStatus } from '@/lib/wsClient';

/**
 * Subscribe to WebSocket status changes from anywhere in the tree.
 * Useful for components that need the status without owning the connection
 * (e.g. the out-of-sync banner mounted at the App root).
 */
export function useWsStatus(): WSStatus {
  const [status, setStatus] = useState<WSStatus>(wsClient.getStatus());
  useEffect(() => {
    return wsClient.onStatus(setStatus);
  }, []);
  return status;
}
